import axios from "axios";

//state
export var userState = {
  user: {},
  userAccounts:[],
  status_user: ""
};

//getters
export var userGetters = {
  //funciones para optener informacion del state
  getUser: state => state.user,
  getUserAccounts: state => state.userAccounts
};

//actions
export var userAcctions = {
  async getUser({ commit }) {
    commit("user_request");
    await axios
      .get("https://jsonplaceholder.typicode.com/posts?userId=1")
      .then(res => {
        const user = { name: "Gabriel", id: "21" };
        commit("user_success", user);
        return user;
      })
      .catch(err => {
        commit("user_error");
        return err;
      });
  },
  async getUserAccounts({commit}){
    commit("partner_request");
    await this._vm.$http
      .get("/apache/rest_api/apache.user.account", {
        headers: {
          "X-Odoo-dbfilter": "apachev1",
          fields:
            "['id','name']"
        }
      })
      .then(res => {
        var userAccounts = res.data;
        commit("userAccounts_success", userAccounts);
        return res;
      })
      .catch(err => {
        commit("partner_error");
        return err;
      });
  }
};

//mutations

export var userMutations = {
  user_request(state) {
    state.status_user = "loading";
  },
  user_success(state, payload) {
    state.status_user = "success";
    state.user = payload;
  },
  userAccounts_success(state, payload) {
    state.status_user = "success";
    state.userAccounts = payload;
  },
  user_error(state) {
    state.status_user = "error";
  }
};
